import { ActionType, createAction } from 'typesafe-actions'

export const NotificationActions = {
  startSignalR: createAction('notifications/START_SIGNALR')()
}

export type NotificationActions = ActionType<typeof NotificationActions>
